import React from 'react';
import ProductHydroTable from './ProductHydroTable';

const ProductHydro = ({ refreshTrigger, exportName }) => (
  <ProductHydroTable refreshTrigger={refreshTrigger} exportName={exportName} />
);

export default ProductHydro;
